import {OperationalHierarchyPermission} from "./OperationalHierarchyPermission";

export const EDIT_DBA_NAME: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditDBAName");

export const MANAGE_SIMPLE_OPERATIONAL_ENTITY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageSimpleOperationalEntity");

export const MANAGE_COMPLEX_OPERATIONAL_ENTITY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageComplexOperationalEntity");

export const MANAGE_SIMPLE_OPERATIONAL_HIERARCHY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageSimpleOperationalHierarchy");

export const MANAGE_COMPLEX_OPERATIONAL_HIERARCHY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageComplexOperationalHierarchy");

export const EDIT_ENTERPRISE_ENTITLEMENTS: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditEnterpriseEntitlements");

export const EDIT_STATUS: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditStatus");

export const EDIT_PARENT_ID: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditParentId");

export const MANAGE_OPERATIONAL_OEMS: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageOperationalOems");

export const EDIT_ADDRESS: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditAddress");

export const EDIT_TELECOM_NUMBERS: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("EditTelecomNumbers");

export const MANAGE_BOID_ENTITIES: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("ManageBOIDEntities");

export const ASSIGN_BOID_ENTITY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("AssignBOIDEntity");

export const UNASSIGN_BOID_ENTITY: OperationalHierarchyPermission =
  new OperationalHierarchyPermission("UnassignBOIDEntity");

export const operationalHierarchyPermissions: OperationalHierarchyPermission[] =
  [
    EDIT_DBA_NAME,
    MANAGE_SIMPLE_OPERATIONAL_ENTITY,
    MANAGE_COMPLEX_OPERATIONAL_ENTITY,
    EDIT_ENTERPRISE_ENTITLEMENTS,
    EDIT_STATUS,
    EDIT_PARENT_ID,
    MANAGE_BOID_ENTITIES,
    ASSIGN_BOID_ENTITY,
    UNASSIGN_BOID_ENTITY,
    EDIT_ADDRESS,
    EDIT_TELECOM_NUMBERS,
    MANAGE_OPERATIONAL_OEMS,
    MANAGE_SIMPLE_OPERATIONAL_HIERARCHY,
    MANAGE_COMPLEX_OPERATIONAL_HIERARCHY
  ];
